import { InslabelListUrlSortField } from "@saleor/inslabel/urls";
import { InstagramLabelSortFidls } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: InslabelListUrlSortField
): InstagramLabelSortFidls {
  switch (sort) {
    case InslabelListUrlSortField.name:
      return InstagramLabelSortFidls.NAME;
    default:
      return undefined;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
